<template>
  <v-app>
    <v-container
      fluid
      style="margin-top: 0%; padding: 0% 0% 0 0; min-height: calc(100vh - 58px)"
    >
      <v-row style="height: 100%; margin: 0; padding: 0; position: relative">
        <v-col cols="12" class="pa-0">
          <GlobalNav />
        </v-col>
        <v-col
          cols="12"
          style="height: 100%"
          class="pa-0 d-flex align-start ga-6"
        >
          <SideBar />
          <div class="w-100 pa-3 is-light-mode">
            <BreadCrumb :linksData="linksData" class="mb-3" />
            <div class="d-flex align-center ga-2 tabs mt-5">
              <div
                class="tab cursor-pointer"
                @click="$router.push({ name: 'MyTeam' })"
              >
                Roles
              </div>
              <div class="tab active">Users</div>
            </div>
            <div class="d-flex align-center justify-end ga-2 mt-5">
              <v-btn
                class="text-capitalize"
                style="box-shadow: none; border: 1px solid #ddd"
                @click="exportToPDF"
                >Export PDF</v-btn
              >
              <span class="add-new-btn" @click="create_user_dialog = true"
                >Create New User</span
              >
            </div>
            <div class="mt-5">
              <v-table>
                <thead>
                  <tr>
                    <th class="text-left">ID</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Role</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in users" :key="user.id">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <span class="d-flex align-center ga-2">
                        <img
                          :title="user.full_name"
                          width="40"
                          height="40"
                          class="circle-img"
                          :src="user.image"
                          :alt="user.full_name"
                        />
                        <span>{{ user.full_name }}</span>
                        <button
                          @click="
                            chooseAccount(user.id, user.image, user.full_name)
                          "
                          v-if="user?.role === 'Client'"
                        >
                          <v-icon
                            color="#1F666A"
                            icon="mdi-account-cog-outline"
                          ></v-icon>
                        </button>
                      </span>
                    </td>
                    <td>{{ user.role }}</td>
                    <td>
                      <span
                        class="user-status green"
                        v-if="user.status === 'Active'"
                      >
                        Active</span
                      >
                      <span
                        class="user-status red"
                        v-if="user.status !== 'Active'"
                      >
                        Inctive</span
                      >
                    </td>
                    <td>
                      <span class="d-flex aligncenter ga-2">
                        <svg
                          @click="
                            edit_user_dialog = true;
                            selected_user_id = user.id;
                          "
                          class="cursor-pointer"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_5780_25679)">
                            <path
                              d="M11.332 2.00004C11.5071 1.82494 11.715 1.68605 11.9438 1.59129C12.1725 1.49653 12.4177 1.44775 12.6654 1.44775C12.913 1.44775 13.1582 1.49653 13.387 1.59129C13.6157 1.68605 13.8236 1.82494 13.9987 2.00004C14.1738 2.17513 14.3127 2.383 14.4074 2.61178C14.5022 2.84055 14.551 3.08575 14.551 3.33337C14.551 3.58099 14.5022 3.82619 14.4074 4.05497C14.3127 4.28374 14.1738 4.49161 13.9987 4.66671L4.9987 13.6667L1.33203 14.6667L2.33203 11L11.332 2.00004Z"
                              stroke="#666666"
                              stroke-width="1.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_5780_25679">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg
                          @click="checkDeleteUser(user.role, user.id)"
                          class="cursor-pointer"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_5780_25681)">
                            <path
                              d="M14.9527 2.105H11.2777V1.61775C11.2772 1.18883 11.1066 0.777618 10.8033 0.474334C10.5 0.17105 10.0888 0.000463179 9.65987 0H6.34363C5.91472 0.000487988 5.50352 0.171086 5.20024 0.474367C4.89696 0.777648 4.72636 1.18885 4.72587 1.61775V2.105H1.05078C0.926461 2.105 0.807233 2.15439 0.719325 2.24229C0.631417 2.3302 0.582031 2.44943 0.582031 2.57375C0.582031 2.69807 0.631417 2.8173 0.719325 2.90521C0.807233 2.99311 0.926461 3.0425 1.05078 3.0425H1.71259V13.1488C1.71341 13.9047 2.01405 14.6294 2.54855 15.1639C3.08306 15.6985 3.80777 15.9991 4.56369 16H11.4398C12.1957 15.9991 12.9204 15.6985 13.4549 15.164C13.9894 14.6295 14.2901 13.9048 14.2909 13.1489V3.0425H14.9527C15.077 3.0425 15.1963 2.99311 15.2842 2.90521C15.3721 2.8173 15.4215 2.69807 15.4215 2.57375C15.4215 2.44943 15.3721 2.3302 15.2842 2.24229C15.1963 2.15439 15.077 2.105 14.9527 2.105ZM5.66337 1.61775C5.66358 1.4374 5.73532 1.2645 5.86284 1.13697C5.99037 1.00944 6.16328 0.937707 6.34363 0.9375H9.65987C9.84023 0.937707 10.0131 1.00944 10.1407 1.13697C10.2682 1.2645 10.3399 1.4374 10.3401 1.61775V2.105H5.66337V1.61775ZM13.3534 13.149C13.3528 13.6563 13.151 14.1427 12.7923 14.5014C12.4335 14.8601 11.9471 15.0619 11.4398 15.0625H4.56369C4.05634 15.0619 3.56994 14.8601 3.2112 14.5014C2.85246 14.1426 2.65066 13.6562 2.65009 13.1489V3.0425H13.3534V13.149ZM7.533 12.3355V5.03716C7.533 4.91284 7.58239 4.79361 7.67029 4.7057C7.7582 4.61779 7.87743 4.56841 8.00175 4.56841C8.12607 4.56841 8.2453 4.61779 8.33321 4.7057C8.42111 4.79361 8.4705 4.91284 8.4705 5.03716V12.3355C8.4705 12.4598 8.42111 12.579 8.33321 12.6669C8.2453 12.7548 8.12607 12.8042 8.00175 12.8042C7.87743 12.8042 7.7582 12.7548 7.67029 12.6669C7.58239 12.579 7.533 12.4598 7.533 12.3355ZM10.7583 11.5268V5.84578C10.7583 5.72146 10.8077 5.60223 10.8956 5.51433C10.9835 5.42642 11.1027 5.37703 11.227 5.37703C11.3514 5.37703 11.4706 5.42642 11.5585 5.51433C11.6464 5.60223 11.6958 5.72146 11.6958 5.84578V11.5268C11.6958 11.6511 11.6464 11.7704 11.5585 11.8583C11.4706 11.9462 11.3514 11.9956 11.227 11.9956C11.1027 11.9956 10.9835 11.9462 10.8956 11.8583C10.8077 11.7704 10.7583 11.6511 10.7583 11.5268ZM4.30772 11.5268V5.84578C4.30772 5.72146 4.3571 5.60223 4.44501 5.51433C4.53292 5.42642 4.65215 5.37703 4.77647 5.37703C4.90079 5.37703 5.02002 5.42642 5.10792 5.51433C5.19583 5.60223 5.24522 5.72146 5.24522 5.84578V11.5268C5.24522 11.6511 5.19583 11.7704 5.10792 11.8583C5.02002 11.9462 4.90079 11.9956 4.77647 11.9956C4.65215 11.9956 4.53292 11.9462 4.44501 11.8583C4.3571 11.7704 4.30772 11.6511 4.30772 11.5268Z"
                              fill="#CC0000"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_5780_25681">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </v-table>

              <div
                id="pdfContent"
                style="
                  direction: rtl;
                  text-align: right;
                  position: absolute;
                  top: -9999px;
                  left: -9999px;
                  z-index: -1;
                  width: 800px;
                "
              >
                <h3>قائمة المستخدمين</h3>
                <table
                  border="1"
                  style="width: 100%; border-collapse: collapse"
                >
                  <thead>
                    <tr>
                      <th>id</th>
                      <th>name</th>
                      <th>role</th>
                      <th>status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in users" :key="user.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ user.full_name }}</td>
                      <td>{{ user.role }}</td>
                      <td>
                        {{ user.status === "Active" ? "نشط" : "غير نشط" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <Pagination
                @PaginationChange="PaginationChanged"
                :pagination="pagination"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
  <CreateUser
    @close="create_user_dialog = false"
    :dialog="create_user_dialog"
    @created="getUsers"
  />
  <EditUser
    @close="edit_user_dialog = false"
    :dialog="edit_user_dialog"
    :id="selected_user_id"
    @updated="getUsers"
  />

  <v-dialog
    v-model="editDialog"
    width="700"
    :key="`edit-${account_users}-${editDialogKey}`"
  >
    <v-card
      max-width="700"
      class="d-flex flex-column mb-0"
      style="max-height: 90vh"
    >
      <v-card-text class="flex-grow-1 overflow-auto mb-0 pb-0">
        <v-container class="ma-0 pa-0">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="d-flex justify-space-between align-center mb-2">
                <h2 style="font-size: 1.3rem">Edit Role</h2>
                <v-icon @click="editDialog = false">mdi-close</v-icon>
              </div>
            </v-col>

            <v-col cols="12">
              <div class="mb-2">
                <v-expansion-panels v-model="openPlatforms">
                  <v-expansion-panel
                    v-for="group in groupedAccounts"
                    :key="group.provider"
                    :value="group.provider"
                  >
                    <!-- عنوان المنصّة -->
                    <v-expansion-panel-title>
                      <div class="d-flex align-center" style="gap: 8px">
                        <img
                          :src="providerMeta[group.provider]?.icon"
                          alt=""
                          style="width: 27px; height: 27px"
                        />
                        <span class="font-weight-medium">
                          {{
                            providerMeta[group.provider]?.name || group.provider
                          }}
                        </span>
                        <span class="text-caption text-medium-emphasis"
                          >({{ group.items.length }})</span
                        >
                      </div>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                      <v-expansion-panels
                        v-model="activeAccountId"
                        @update:modelValue="onExpand"
                      >
                        <v-expansion-panel
                          v-for="account in group.items"
                          :key="account.id"
                          :value="account.id"
                        >
                          <v-expansion-panel-title>
                            {{ account.account_name }}
                          </v-expansion-panel-title>

                          <v-expansion-panel-text>
                            <!-- داخل v-expansion-panel-text بتاع الحساب -->

                            <v-autocomplete
                              v-if="
                                (campaignsByAccount[account.id] || []).length
                              "
                              :key="`acct-${account.id}`"
                              v-model="selectionsRaw[account.id]"
                              :items="campaignsByAccount[account.id] || []"
                              item-title="campaign_name"
                              item-value="__valueKey"
                              multiple
                              return-object
                              clearable
                              chips
                              closable-chips
                              hide-details
                              variant="outlined"
                              density="comfortable"
                              rounded="lg"
                              :menu-props="{
                                maxHeight: 320,
                                offset: 6,
                                eager: true,
                                transition: 'fade-transition',
                              }"
                              class="campaign-select"
                              @update:modelValue="onCampaignSelect(account.id)"
                            >
                              <template #item="{ item, props }">
                                <v-list-item v-bind="props" class="item-row">
                                  <div class="item-title">
                                    {{ item.raw.campaign_name }}
                                  </div>
                                  <div class="item-id">
                                    ({{ item.raw.campaign_id }})
                                  </div>
                                </v-list-item>
                              </template>

                              <template #selection="{ item }">
                                <v-chip
                                  :key="item.raw.__valueKey"
                                  size="small"
                                  :color="providerColor(group.provider)"
                                  text-color="white"
                                  class="campaign-chip"
                                  closable
                                  @click:close="
                                    selectionsRaw[account.id] = (
                                      selectionsRaw[account.id] || []
                                    ).filter(
                                      (c) =>
                                        c.__valueKey !== item.raw.__valueKey
                                    )
                                  "
                                >
                                  {{ item.raw.campaign_name }}
                                </v-chip>
                              </template>
                            </v-autocomplete>

                            <div
                              v-else
                              class="text-grey mt-2"
                              style="font-size: 12px"
                            >
                              No campaigns found for this account.
                            </div>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="justify-end border-t">
        <v-btn
          color="#fff"
          style="background-color: #3e8487; font-size: 14px"
          class="mr-2 px-6"
          @click="saveSelections"
        >
          Save
        </v-btn>
        <v-btn
          color="#000"
          class="px-6"
          style="background-color: #f2f2f2; font-size: 14px"
          @click="editDialog = false"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="delete_user_dialog" width="auto">
    <v-card max-width="550">
      <template v-slot:text>
        <div>
          <div class="d-flex justify-space-between align-center mb-8">
            <svg
              width="56"
              height="57"
              viewBox="0 0 56 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="4.5"
                width="48"
                height="48"
                rx="24"
                fill="#FEE4E2"
              />
              <rect
                x="4"
                y="4.5"
                width="48"
                height="48"
                rx="24"
                stroke="#FEF3F2"
                stroke-width="8"
              />
              <path
                d="M32 22.5V21.7C32 20.5799 32 20.0198 31.782 19.592C31.5903 19.2157 31.2843 18.9097 30.908 18.718C30.4802 18.5 29.9201 18.5 28.8 18.5H27.2C26.0799 18.5 25.5198 18.5 25.092 18.718C24.7157 18.9097 24.4097 19.2157 24.218 19.592C24 20.0198 24 20.5799 24 21.7V22.5M26 28V33M30 28V33M19 22.5H37M35 22.5V33.7C35 35.3802 35 36.2202 34.673 36.862C34.3854 37.4265 33.9265 37.8854 33.362 38.173C32.7202 38.5 31.8802 38.5 30.2 38.5H25.8C24.1198 38.5 23.2798 38.5 22.638 38.173C22.0735 37.8854 21.6146 37.4265 21.327 36.862C21 36.2202 21 35.3802 21 33.7V22.5"
                stroke="#CC0000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              @click="delete_user_dialog = false"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="cursor-pointer hoverd"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#717680"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="delete-dialog-body">
            <div class="main mb-2">
              Are you sure you want to delete this item
            </div>
            <div class="sub">
              If you deleted this item you won’t be able to restore it again
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <div class="pa-4 d-flex align-center ga-3">
          <v-btn
            class="cancel-btn"
            text="Cancel"
            @click="delete_user_dialog = false"
          ></v-btn>
          <v-btn
            class="delete-btn text-capitalize"
            color="white"
            text="Delete"
            @click="deleteUser"
          ></v-btn>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import "@/assets/css/team/style.css";
import apiClient from "@/core/buildRequest";
import CreateUser from "@/components/team/CreateUser.vue";
import EditUser from "@/components/team/EditUser.vue";
import { useGeneralStore } from "@/store/General";
import Pagination from "@/views/MyTeam/Pagination.vue";
import selectaccid from "@/components/team/selectaccid.vue";
import { nextTick } from "vue";
import "jspdf-autotable";
import html2pdf from "html2pdf.js";
import facebookIcon from "@/assets/soft-ware-img/facebook-post-select.svg";
import snapchatIcon from "@/assets/soft-ware-img/snapchat-logo-svgrepo-com.svg";
import xIcon from "@/assets/soft-ware-img/x-twitter-icons.svg";
import tiktokIcon from "@/assets/soft-ware-img/tikTopkcampaign.svg";

export default {
  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
    CreateUser,
    EditUser,
    Pagination,
    selectaccid,
  },

  data() {
    return {
      facebookIcon,
      snapchatIcon,
      xIcon,
      tiktokIcon,
      linksData: [
        { name: "Home", link: "/" },
        { name: "My Team", link: "" },
      ],
      create_user_dialog: false,
      users: [],
      general_store: useGeneralStore(),
      selected_user_id: null,
      delete_user_dialog: false,
      edit_user_dialog: false,
      pagination: {
        total_items: 0,
        count_items: 0,
        total_pages: 0,
        current_page: 0,
        next_page_url: "",
        perv_page_url: "",
      },
      current_page: 1,
      current_items_per_page: 10,
      editDialog: false,
      account_users: null,
      account_image: null,
      account_name: null,
      accounts: [],
      campaigns: [],
      campaignsByAccount: {}, // { [accountId]: Campaign[] }
      selectionsRaw: {}, // { [accountId]: Campaign[] } ← كائنات كاملة من v-select
      activeAccountId: null,
      providerMeta: {
        facebook: { name: "Facebook", icon: facebookIcon },
        snapchat: { name: "Snapchat", icon: snapchatIcon },
        twitter: { name: "X (Twitter)", icon: xIcon },
        tiktok: { name: "TikTok", icon: tiktokIcon },
      },
      providerOrder: ["facebook", "snapchat", "tiktok", "twitter"],
      openPlatforms: [],
      providerColors: {
        facebook: "#1877F2",
        snapchat: "#FFFC00",
        tiktok: "#111111",
        twitter: "#1DA1F2",
        other: "#666666",
      },
      editDialogKey: 0,
      selectionsRawByUser: {},
      campaignsByAccountByUser: {},
    };
  },
  mounted() {
    this.getUsers();
    if (this.groupedAccounts[0])
      this.openPlatforms = [this.groupedAccounts[0].provider];
  },
  computed: {
    // بيرجّع Array مرتّبة: [{ provider, items: [...] }, ...]
    groupedAccounts() {
      const groups = {};
      (this.accounts || []).forEach((acc) => {
        const key = acc.provider || "other";
        if (!groups[key]) groups[key] = [];
        groups[key].push(acc);
      });

      const ordered = [];
      this.providerOrder.forEach((p) => {
        if (groups[p]?.length) {
          groups[p].sort((a, b) =>
            (a.account_name || "").localeCompare(b.account_name || "")
          );
          ordered.push({ provider: p, items: groups[p] });
        }
      });
      Object.keys(groups).forEach((p) => {
        if (!this.providerOrder.includes(p)) {
          groups[p].sort((a, b) =>
            (a.account_name || "").localeCompare(b.account_name || "")
          );
          ordered.push({ provider: p, items: groups[p] });
        }
      });
      return ordered;
    },
    // Array موحّدة من كل الحسابات: [{ campaign_id, campaign_platform }, ...]
    allSelectedCampaignPairs() {
      return Object.values(this.selectionsRaw)
        .flat()
        .map((c) => ({
          campaign_id: c.campaign_id,
          campaign_platform: c.campaign_platform,
          ad_account_id: c.ad_account_id,
        }));
    },
  },
  methods: {
    resetPickerState() {
      // لو هتـnamespace:
      this.selectionsRawByUser[this.account_users] = {};
      this.campaignsByAccountByUser[this.account_users] = {};
      // واشتق شورتكات متفاعلة:
      this.selectionsRaw = this.selectionsRawByUser[this.account_users];
      this.campaignsByAccount =
        this.campaignsByAccountByUser[this.account_users];
      this.activeAccountId = null;
      this.openPlatforms = [];
    },
    providerColor(p) {
      return this.providerColors[p] || this.providerColors.other;
    },
    exportToPDF() {
      nextTick(() => {
        setTimeout(() => {
          const element = document.getElementById("pdfContent");
          if (!element) {
            console.error("pdfContent not found");
            return;
          }

          // ✅ اظهار العنصر مؤقتاً
          element.style.position = "static";
          element.style.top = "auto";
          element.style.left = "auto";
          element.style.zIndex = "auto";

          const opt = {
            margin: 0.5,
            filename: "users-arabic.pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: {
              scale: 2,
              useCORS: true,
            },
            jsPDF: {
              unit: "in",
              format: "a4",
              orientation: "portrait",
            },
          };

          html2pdf()
            .from(element)
            .set(opt)
            .save()
            .then(() => {
              // ✅ اخفاء العنصر بعد الحفظ
              element.style.position = "absolute";
              element.style.top = "-9999px";
              element.style.left = "-9999px";
              element.style.zIndex = "-1";
            });
        }, 300);
      });
    },
    PaginationChanged({ page, items_per_page }) {
      this.current_page = page;
      this.current_items_per_page = items_per_page;
      this.getUsers();
    },
    getUsers() {
      apiClient
        .get(`/my-team/list-users`, {
          params: {
            page: this.current_page,
            per_page: this.current_items_per_page,
          },
        })
        .then((response) => {
          this.users = response.data.data.data;
          this.pagination = {
            total_items: response.data.data.pagination.total_items,
            count_items: response.data.data.pagination.count_items,
            total_pages: response.data.data.pagination.total_pages,
            current_page: response.data.data.pagination.current_page,
            next_page_url: response.data.data.pagination.next_page_url,
            perv_page_url: response.data.data.pagination.perv_page_url,
          };
        })
        .catch((error) => {
          this.general_store.showSnackbar("Failed to fetch users", "error");
        });
    },
    deleteUser() {
      apiClient
        .get(`/my-team/delete-user/${this.selected_user_id}`)
        .then(() => {
          this.getUsers();
          this.delete_user_dialog = false;
          this.general_store.showSnackbar(
            "User Deleted Successfully",
            "success"
          );
        })
        .catch((error) => {
          this.delete_user_dialog = false;
          this.general_store.showSnackbar("Failed to delete user", "error");
        });
    },
    checkDeleteUser(role, id) {
      if (role != "Super Admin") {
        this.selected_user_id = id;
        this.delete_user_dialog = true;
      } else {
        this.general_store.showSnackbar(
          "Super Admin cannot be deleted",
          "error"
        );
      }
    },
    chooseAccount(userId, image, name) {
      this.account_users = userId; // client_id
      this.account_image = image;
      this.account_name = name;

      // صفّر الحالة قبل الفتح
      this.resetPickerState();
      // زود key علشان يضمن إعادة mount للديالوج ومكوناته
      this.editDialogKey++;

      this.editDialog = true;
      this.getAllAccounts();
    },
    getAllAccounts() {
      apiClient
        .get("/super-ad/platforms-account")
        .then((response) => {
          console.log(response.data.data.data);
          this.accounts = response.data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching accounts:", error);
        });
    },
    getProviderForAccount(account_id) {
      const acc = (this.accounts || []).find((a) => a.id === account_id);
      return acc?.provider || "other";
    },
    onExpand(val) {
      const accountId = Array.isArray(val) ? val[0] : val;
      if (!accountId) return;
      this.activeAccountId = accountId;
      const platform = this.getProviderForAccount(accountId);
      const clientId = this.account_users; // ده عندك هو client_id اللي اتخزن في chooseAccount
      this.getRelatedCampaigns({
        account_id: accountId,
        client_id: clientId,
        platform,
      });
      if (!this.selectionsRaw[accountId]) this.selectionsRaw[accountId] = [];
    },

    getRelatedCampaigns({ account_id, client_id, platform }) {
      apiClient
        .get(`/client/account-campaigns`, {
          params: { account_id, client_id, platform },
        })
        .then(({ data }) => {
          const raw = data?.data ?? [];
          // clone + مفتاح فريد يمنع تسرّب المراجع
          const list = raw.map((c) => ({
            ...c,
            __valueKey: `${c.ad_account_id}:${c.campaign_platform}:${c.campaign_id}`,
          }));

          // خزن لِحساب واحد فقط (أو per-user لو عامل namespace)
          this.campaignsByAccount[account_id] = list;

          // preselect من نفس list (مش من raw) عشان مرجع مستقل
          this.selectionsRaw[account_id] = list.filter((c) => c.selected);
        });
    },

    onCampaignSelect(account_id) {
      // اختيارات الحساب ده (كائنات كاملة)
      const current = this.selectionsRaw[account_id] || [];
      // لو عايز تشوفهم كـ {campaign_id, campaign_platform}
      const pairs = current.map((c) => ({
        campaign_id: c.campaign_id,
        campaign_platform: c.campaign_platform,
        ad_account_id: c.ad_account_id,
      }));
      console.log("Account", account_id, "pairs:", pairs);

      // كل الاختيارات من كل الحسابات:
      console.log("ALL pairs:", this.allSelectedCampaignPairs);
    },
    // مثال إرسال للباك إند
    saveSelections() {
      // 1) كل الاختيارات المجمعة: [{campaign_id, campaign_platform, ad_account_id}]
      const selected = this.allSelectedCampaignPairs || [];
      if (!selected.length) {
        this.general_store.showSnackbar("اختر حملات أولاً", "error");
        return;
      }
      // 2) ad_accounts[] = unique ad_account_id من كل الاختيارات
      const adAccountIds = [
        ...new Set(selected.map((s) => s.ad_account_id).filter(Boolean)),
      ];
      // 3) ابنِ الـ FormData بالمفاتيح المطلوبة
      const fd = new FormData();
      fd.append("client_id", this.account_users); // ده عندك هو user id/ client id

      adAccountIds.forEach((id, idx) => {
        fd.append(`ad_accounts[${idx}]`, String(id));
      });

      selected.forEach((c, idx) => {
        // campaigns[0][campaign_id] , campaigns[0][provider]
        fd.append(`campaigns[${idx}][campaign_id]`, String(c.campaign_id));
        // تحويل campaign_platform => provider حسب المطلوب في الباك إند
        fd.append(`campaigns[${idx}][provider]`, String(c.campaign_platform));
      });

      // 4) الإرسال
      apiClient
        .post("/client/assign-accounts", fd)
        .then((res) => this.general_store.showSnackbar(res.data.msg, "success"))
        .catch(() => this.general_store.showSnackbar("Failed to save", "error"))
        .finally(() => {
          this.editDialog = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-select .v-field__outline {
  display: none;
}
::v-deep .v-select {
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>
